import { Constants } from '@pwc/pwc-deals-web-common';

const CONSTANTS = Object.freeze({
  TABS: {
    EDIT_LAYOUT: 'Edit Layout',
    SAVE_PREVIEW_REPORT: 'Save and preview report',
  },
  TABS_ROUTE: {
    LAYOUT: 'layout',
    PREVIEW: 'preview',
  },
  SUB_ROUTES: {
    CREATE_PREVIEW: '/projects/:projectId/analyses/create/layout/preview',
    CREATE_LAYOUT: '/projects/:projectId/analyses/create/layout',
    EDIT_PREVIEW:
      '/projects/:projectId/analyses/:analysisId/edit/layout/preview',
    EDIT_LAYOUT: '/projects/:projectId/analyses/:analysisId/edit/layout',
  },
  PARTIAL_ROUTE: {
    CREATE_LAYOUT: 'create/layout',
    EDIT_LAYOUT: 'edit/layout',
    CREATE_LAYOUT_PREVIEW: 'create/layout/preview',
    EDIT_LAYOUT_PREVIEW: 'edit/layout/preview',
  },
  COLUMN_TYPE: {
    ONE: 'ONE_COLUM',
    TWO: 'TWO_COLUM',
    THREE: 'THREE_COLUM',
    FOUR: 'FOUR_COLUM',
  },
  USER_EVENTS: {
    SCROLL: 'scroll',
    RESIZE: 'resize',
    KEY_DOWN: 'keydown',
  },
  PO_TOPIC_LAYOUT_TYPE_TO_LAYOUT_TITLE_DESCRIPTION_MAP: {
    [Constants.TOPIC_LAYOUT_TYPE.ONE_COLUMN.value]: {
      title: 'layout.oneColFullWidth.title',
      description: 'layout.oneColFullWidth.description',
      blocks: 1,
    },
    [Constants.TOPIC_LAYOUT_TYPE.TWO_COLUMN.value]: {
      title: 'layout.twoCol.title',
      description: 'layout.twoCol.description',
      blocks: 2,
    },
    [Constants.TOPIC_LAYOUT_TYPE.THREE_COLUMN.value]: {
      title: 'layout.threeCol.title',
      description: 'layout.threeCol.description',
      blocks: 3,
    },
    [Constants.TOPIC_LAYOUT_TYPE.TWO_COLUMN_L_50_2A_R_50_1A.value]: {
      title: 'layout.stackedWithRigthCol.title',
      description: 'layout.stackedWithRigthCol.description',
      blocks: 3,
    },
    [Constants.TOPIC_LAYOUT_TYPE.TWO_COLUMN_L_67_1A_R_33_1A.value]: {
      title: 'layout.twoColNarrowRight.title',
      description: 'layout.twoColNarrowRight.description',
      blocks: 2,
    },
    [Constants.TOPIC_LAYOUT_TYPE.TWO_ROW_T_80_1A_B_20_1A.value]: {
      title: 'layout.stackedLargeTop.title',
      description: 'layout.stackedLargeTop.description',
      blocks: 2,
    },
    [Constants.TOPIC_LAYOUT_TYPE.TWO_ROW_T_60_1A_B_40_1A.value]: {
      title: 'layout.stackedMediumTop.title',
      description: 'layout.stackedMediumTop.description',
      blocks: 2,
    },
    [Constants.TOPIC_LAYOUT_TYPE.TWO_ROW_T_50_1A_B_50_2A.value]: {
      title: 'layout.stackedTwoBlockBottom.title',
      description: 'layout.stackedTwoBlockBottomV2.description',
      blocks: 3,
    }, // TODO: fix left side layout 18, it should be TWO_ROW_T_100_1A_B_50_2A
    INDICATOR_TOOLTIP: 'changingToThisLayoutWillDelete',
  },
  LAYOUT_TYPE_TO_LAYOUT_TITLE_DESCRIPTION_MAP: {
    [Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN]: {
      title: 'layout.oneColFullWidth.title',
      description: 'layout.oneColFullWidth.description',
      blocks: 1,
    },
    [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN]: {
      title: 'layout.twoCol.title',
      description: 'layout.twoCol.description',
      blocks: 2,
    },
    [Constants.SECTION_LAYOUT_TYPE.THREE_COLUMN]: {
      title: 'layout.threeCol.title',
      description: 'layout.threeCol.description',
      blocks: 3,
    },
    [Constants.SECTION_LAYOUT_TYPE.THREE_ROWS]: {
      title: 'layout.threeStacked.title',
      description: 'layout.threeStacked.description',
      blocks: 3,
    },
    [Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_80]: {
      title: 'layout.oneColLarge.title',
      description: 'layout.oneColLarge.description',
      blocks: 1,
    },
    [Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_60]: {
      title: 'layout.oneColMedium.title',
      description: 'layout.oneColMedium.description',
      blocks: 1,
    },
    [Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_40]: {
      title: 'layout.oneColSmall.title',
      description: 'layout.oneColSmall.description',
      blocks: 1,
    },
    [Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_OVERFLOW_AREA]: {
      title: 'layout.twoColTextOnly.title',
      description: 'layout.twoColTextOnly.description',
      blocks: 2,
    },
    [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_50_2A_R_50_1A]: {
      title: 'layout.stackedWithRigthCol.title',
      description: 'layout.stackedWithRigthCol.description',
      blocks: 3,
    },
    [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_50_3A_R_50_1A]: {
      title: 'layout.threeStackedWithRightCol.title',
      description: 'layout.threeStackedWithRightCol.description',
      blocks: 4,
    },
    [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_40_1A_R_60_1A]: {
      title: 'layout.twoColNarrowLeft.title',
      description: 'layout.twoColNarrowLeft.description',
      blocks: 2,
    },
    [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_67_1A_R_33_1A]: {
      title: 'layout.twoColNarrowRight.title',
      description: 'layout.twoColNarrowRight.description',
      blocks: 2,
    },
    [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_67_2A_R_33_1A]: {
      title: 'layout.stackedNarrowRight.title',
      description: 'layout.stackedNarrowRight.descriptio',
      blocks: 3,
    },
    [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_80_1A_R_20_1A]: {
      title: 'layout.twoColExtraNarrowRight.title',
      description: 'layout.twoColExtraNarrowRight.description',
      blocks: 2,
    },
    [Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_80_1A_B_20_1A]: {
      title: 'layout.stackedLargeTop.title',
      description: 'layout.stackedLargeTop.description',
      blocks: 2,
    },
    [Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_60_1A_B_40_1A]: {
      title: 'layout.stackedMediumTop.title',
      description: 'layout.stackedMediumTop.description',
      blocks: 2,
    },
    [Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_20_1A_B_80_1A]: {
      title: 'layout.stackedLargeBottom.title',
      description: 'layout.stackedLargeBottom.description',
      blocks: 2,
    },
    [Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_50_2A_B_50_1A]: {
      title: 'layout.stackedTwoBlockTop.title',
      description: 'layout.stackedTwoBlockTop.description',
      blocks: 3,
    }, // TODO: fix left side layout 17, it should be TWO_ROW_T_50_2A_B_100_1A
    [Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_50_1A_B_50_2A]: {
      title: 'layout.stackedTwoBlockBottom.title',
      description: 'layout.stackedTwoBlockBottom.description',
      blocks: 3,
    }, // TODO: fix left side layout 18, it should be TWO_ROW_T_100_1A_B_50_2A
    [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_TWO_ROW_50_2A_50_2A]: {
      title: 'layout.fourBlock.title',
      description: 'layout.fourBlock.description',
      blocks: 4,
    },
    [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_TWO_ROW_67_2A_33_2A]: {
      title: 'layout.fourBlockNarrowRight.title',
      description: 'layout.fourBlockNarrowRight.description',
      blocks: 4,
    },
    [Constants.SECTION_LAYOUT_TYPE.THREE_COLUMN_TWO_ROW]: {
      title: 'layout.sixBlock.title',
      description: 'layout.sixBlock.description',
      blocks: 6,
    },
  },
  LAYOUT_TYPE_TO_SECTION_CLASSNAME_MAP: {
    // 1
    [Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN]: 'one-column',
    // 2
    [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN]: 'two-column',
    // 3
    [Constants.SECTION_LAYOUT_TYPE.THREE_COLUMN]: 'three-column',
    // 4
    [Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_80]: 'one-column-80',
    // 5
    [Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_60]: 'one-column-60',
    // 6
    [Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_40]: 'one-column-40',
    // 7
    [Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_OVERFLOW_AREA]:
      'one-column-text-overflow-area',
    // 8
    [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_50_2A_R_50_1A]:
      'two-column-three-area-2left50-right50',
    // 9
    [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_50_3A_R_50_1A]:
      'two-column-four-area-3left50-right50',
    // 10
    [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_40_1A_R_60_1A]:
      'two-column-left40-right60',
    // 11
    [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_67_1A_R_33_1A]:
      'two-column-left67-right33',
    // 12
    [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_67_2A_R_33_1A]:
      'two-column-three-area-2left67-right33',
    // 13
    [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_80_1A_R_20_1A]:
      'two-column-left80-right20',
    // 14
    [Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_80_1A_B_20_1A]:
      'two-row-top80-bottom20',
    // 15
    [Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_60_1A_B_40_1A]:
      'two-row-top60-bottom40',
    // 16
    [Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_20_1A_B_80_1A]:
      'two-row-top20-bottom80',
    // 17
    [Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_50_2A_B_50_1A]:
      'two-row-three-area-2top50-bottom100',
    // 18
    [Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_50_1A_B_50_2A]:
      'two-row-three-area-top100-2bottom50',
    // 19
    [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_TWO_ROW_50_2A_50_2A]:
      'two-row-two-column-50-50',
    // 20
    [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_TWO_ROW_67_2A_33_2A]:
      'two-row-two-column-67-33',
    // 21
    [Constants.SECTION_LAYOUT_TYPE.THREE_COLUMN_TWO_ROW]:
      'two-row-three-column',
    // 22
    [Constants.SECTION_LAYOUT_TYPE.THREE_ROWS]: 'three-column-stacked',
  },
  VIEWPORT_WIDTHS: {
    MOBILE: 577,
    TABLET: 768,
    TABLET_LARGE: 991,
    SMALLER_SCREENS: 1199,
  },
  LAYOUT_TYPE_TO_ICON_MAP: {
    // positions:
    // one area
    '1-1': 'one-column-full-width',
    '4-1': 'one-column-large',
    '5-1': 'one-column-medium',
    '6-1': 'one-column-small',
    '7-1': 'two-column-text-only',

    // two areas
    '10-1': 'two-column-narrow-left-left',
    '10-2': 'two-column-narrow-left-right',

    '11-1': 'two-column-narrow-right-left',
    '11-2': 'two-column-narrow-right-right',

    '2-1': 'two-column-left',
    '2-2': 'two-column-right',

    '15-1': 'stacked-medium-top-top',
    '15-2': 'stacked-medium-top-bottom',

    '14-1': 'stacked-large-top-top',
    '14-2': 'stacked-large-top-bottom',

    '16-1': 'stacked-large-bottom-top',
    '16-2': 'stacked-large-bottom-bottom',

    '13-1': 'two-column-extra-narrow-right-left',
    '13-2': 'two-column-extra-narrow-right-right',

    // three areas
    '3-1': 'three-column-left',
    '3-2': 'three-column-middle',
    '3-3': 'three-column-right',

    '8-1': 'stacked-with-right-column-top-left',
    '8-2': 'stacked-with-right-column-right',
    '8-3': 'stacked-with-right-column-bottom-left',

    '12-1': 'stacked-with-narrow-right-column-top-left',
    '12-2': 'stacked-with-narrow-right-column-right',
    '12-3': 'stacked-with-narrow-right-column-bottom-left',

    '17-1': 'stacked-two-block-top-top-left',
    '17-2': 'stacked-two-block-top-top-right',
    '17-3': 'stacked-two-block-top-bottom',

    '18-1': 'stacked-two-block-bottom-top',
    '18-2': 'stacked-two-block-bottom-bottom-left',
    '18-3': 'stacked-two-block-bottom-bottom-right',

    // four areas
    '19-1': 'four-block-top-left',
    '19-2': 'four-block-top-right',
    '19-3': 'four-block-bottom-left',
    '19-4': 'four-block-bottom-right',

    '20-1': 'four-block-narrow-right-top-left',
    '20-2': 'four-block-narrow-right-top-right',
    '20-3': 'four-block-narrow-right-bottom-left',
    '20-4': 'four-block-narrow-right-bottom-right',

    '9-1': 'three-stacked-with-right-column-left-top',
    '9-2': 'three-stacked-with-right-column-right',
    '9-3': 'three-stacked-with-right-column-left-middle',
    '9-4': 'three-stacked-with-right-column-left-bottom',

    '21-1': 'six-block-top-left',
    '21-2': 'six-block-top-middle',
    '21-3': 'six-block-top-right',
    '21-4': 'six-block-bottom-left',
    '21-5': 'six-block-bottom-middle',
    '21-6': 'six-block-bottom-right',
  },
});
export default CONSTANTS;
